import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Form, Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


import { Formik } from 'formik';
import * as yup from 'yup';



import Dialog from '../../services/Dialogs'



import { labelPrivilegio, descargarArchivo } from '../../services/funcionesPublicas'


const ModalMovimientoAdministrativo = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, empleado } = params


  const dialog = new Dialog();



  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({

          idpuesto : yup.string().nullable(),
          iddepartamento : yup.string().nullable(),
          idsucursal : yup.string().nullable(),

  });



const [ envio_server, setSeEnvio ] = useState<boolean>(false)


const enviarFormulario = async (registro:any,event:any) =>{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ''
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update( `recursos_humanos/movimiento_administrativo/${empleado.uuid}` , { ...registro })

        if(res_){
          toast.warning('El Movimiento se realizó. Recuerda hacer la notificación al empleado.')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}

    // 'GET /' : 'Registro.lista_departamentos',
    // 'GET /' : 'Registro.lista_puestos',



  const [ departamentos, setDepartamentos] = useState<any>([])

  const cargarDepartamentos = async() => {

    try{
      let res = await RequestService.getEndPoint('registro/lista_departamentos')
      setDepartamentos(res.data)
    }
    catch(e){
      toast.error('Tuvimos problemas al cargar la lista de departamentos')
    }

  }


  const [ puestos, setPuestos] = useState<any>([])

  const cargarPuestos = async() => {

    try{
      let res = await RequestService.getEndPoint('registro/lista_puestos')
      setPuestos(res.data)
    }
    catch(e){
      toast.error('Tuvimos problemas al cargar la lista de puestos')
    }

  }


  const [ sucursales, setSucursales] = useState<any>([])

  const cargarSucursales = async() => {

    try{
      let res = await RequestService.getEndPoint('sucursales')
      setSucursales(res.data)
    }
    catch(e){
      toast.error('Tuvimos problemas al cargar la lista de sucursales')
    }

  }




  React.useEffect(() => {
    cargarDepartamentos()
    cargarSucursales()
    cargarPuestos()
  }, []);







  return (
    <>

    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{

            idpuesto : empleado.idpuesto ? empleado.idpuesto.uuid : null,
            iddepartamento : empleado.iddepartamento ? empleado.iddepartamento.uuid : null,
            idsucursal : empleado.idsucursal ? empleado.idsucursal.uuid : null,

      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (



            <Modal show={show} onHide={handleClose} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Cambio Administrativo</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {

                }


              <small>Empleado</small>
              <h6>{empleado.nombres} {empleado.paterno} {empleado.materno}</h6>

              <small>Rol</small>
              <h6>{labelPrivilegio(empleado.rol)}</h6>


              <Form id='my-form' noValidate onSubmit={handleSubmit}>


              {
                // JSON.stringify(values)
              }
              {
                // JSON.stringify(empleado.idsucursal)
              }





                    <Form.Group className="mb-3" controlId="idsucursal">
                      <Form.Label>Selecciona a la Sucursal</Form.Label>
                      <Form.Select required name="idsucursal" value={values.idsucursal} onChange={(e)=>{ setFieldValue('idsucursal', e.target.value ) }} isInvalid={!!errors.idsucursal}>
                        <option disabled={values.idsucursal!==''} value="">SELECCIONA UNA SUCURSAL</option>
                        
                          {
                            sucursales.map( sucursal =>
                              <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                        <option value={sucursal.uuid}> {sucursal.nombre_sucursal}</option>
                              </React.Fragment>
                            )
                          }

                      </Form.Select>
                      <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                      <Form.Control.Feedback type="invalid"> {errors.idsucursal} </Form.Control.Feedback>
                    </Form.Group>

                   
                      {
                        ['ROLE_GERENTE','ROLE_GERENTE_JR','ROLE_ASESOR','ROLE_ASESOR_BASE','ROLE_DIRECTOR_COMERCIAL','ROLE_ASISTENTE','ROLE_SUPERVISOR'].indexOf(empleado.rol) < 0 && (
                              <>

                                    <Form.Group className="mb-3" controlId="iddepartamento">
                                      <Form.Label>Departamento</Form.Label>
                                      <Form.Select required name="iddepartamento" value={values.iddepartamento} onChange={(e)=>{ setFieldValue('iddepartamento', e.target.value ) }} isInvalid={!!errors.iddepartamento}>
                                        <option disabled={values.iddepartamento!==''} value="">SELECCIONA UN DEPARTAMENTO</option>

                                          {
                                            departamentos.map( departamento =>
                                              <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                                        <option value={departamento.uuid}> {departamento.departamento}</option>
                                              </React.Fragment>
                                            )
                                          }

                                      </Form.Select>
                                      <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                      <Form.Control.Feedback type="invalid"> {errors.iddepartamento} </Form.Control.Feedback>
                                    </Form.Group>

                           


                                    <Form.Group className="mb-3" controlId="idpuesto">
                                      <Form.Label>Puesto</Form.Label>
                                      <Form.Select required name="idpuesto" value={values.idpuesto} onChange={(e)=>{ setFieldValue('idpuesto', e.target.value ) }} isInvalid={!!errors.idpuesto}>
                                        <option disabled={values.idpuesto!==''} value="">SELECCIONA UN PUESTO</option>
                                        
                                          {
                                            puestos.map( puesto =>
                                              <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                                        <option value={puesto.uuid}> {puesto.puesto}</option>
                                              </React.Fragment>
                                            )
                                          }

                                      </Form.Select>
                                      <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                      <Form.Control.Feedback type="invalid"> {errors.idpuesto} </Form.Control.Feedback>
                                    </Form.Group>

           


                              </>
                          )
                      }



                  </Form>



              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Cancelar
                </Button>
                

                      {
                        ['ROLE_GERENTE','ROLE_GERENTE_JR','ROLE_ASESOR','ROLE_ASESOR_BASE','ROLE_DIRECTOR_COMERCIAL','ROLE_ASISTENTE','ROLE_SUPERVISOR'].indexOf(empleado.rol) < 0 && (
                            <Button variant="success" 
                            disabled={ ( values.idsucursal === empleado.idsucursal.uuid && values.idpuesto === empleado.idpuesto.uuid && values.iddepartamento === empleado.iddepartamento.uuid   ) }
                            form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
                          )
                      }


                      {
                        ['ROLE_GERENTE','ROLE_GERENTE_JR','ROLE_ASESOR','ROLE_ASESOR_BASE','ROLE_DIRECTOR_COMERCIAL','ROLE_ASISTENTE','ROLE_SUPERVISOR'].indexOf(empleado.rol) > -1 && (
                            <Button variant="success" 
                            disabled={ ( values.idsucursal === empleado.idsucursal.uuid ) }
                            form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
                          )
                      }

                






              </Modal.Footer>
            </Modal>




      )}
    </Formik>


    </>
  );
}


export default ModalMovimientoAdministrativo;